<template>
  <div class="sb-minibrowser__list">
    <SbMiniBrowserListHeader
      v-if="isInternalTitleVisible"
      :title="title"
      :data-testid="`${dataTestid}-header`"
    />

    <slot name="header" :title="title" />

    <slot
      name="items"
      :items="items"
      :browser-list-id="context.browserListId"
    />

    <SbDropdown
      v-if="!$slots.items"
      :id="context.browserListId"
      inline
      @keydown="handleKeydown"
    >
      <SbMiniBrowserListItem
        v-for="(item, key) in items"
        :key="key"
        v-bind="{
          ...item,
          label: item.label ?? '',
          modelValue: item.value,
        }"
        :data-testid="`${dataTestid}-item-${key}`"
      />
      <SbMinibrowserLoadMore />
    </SbDropdown>
  </div>
</template>

<script lang="ts" setup>
import { computed, useAttrs, useSlots } from 'vue'
import SbMiniBrowserListItem from './MinibrowserListItem.vue'
import SbMiniBrowserListHeader from './MinibrowserListHeader.vue'
import SbMinibrowserLoadMore from './MinibrowserLoadMore.vue'
import SbDropdown from '../../Dropdown/SbDropdown.vue'
import type { MinibrowserOption } from '../types'
import { useMinibrowser } from '../utils'

const slots = useSlots()

type SbMinibrowserList = {
  /**
   * List of items to be displayed in the minibrowser
   */
  items?: MinibrowserOption[]

  /**
   * If the list is a group of items
   */
  group?: boolean

  /**
   * Title of the list
   */
  title?: string
}

const props = withDefaults(defineProps<SbMinibrowserList>(), {
  title: undefined,
  items: () => [],
})

const { context } = useMinibrowser()
const dataTestid = computed(
  () => useAttrs()['data-testid'] || 'sb-mini-browser-list',
)

const isInternalTitleVisible = computed(
  (): boolean => Boolean(props.title) && !slots.header,
)

const handleKeydown = (event: KeyboardEvent) => {
  context.value.handleKeydownOnList(event, {
    onEscape: () => (context.value.shouldFocusOnInput.value = true),
  })
}
</script>
